import { createSelector } from 'reselect'
import { EmptyArray } from 'lib/array/arrayUtils'
import getMerchandiseShippingItemViews from 'checkout/selectors/view/itemViews/getMerchandiseShippingItemViews'

const getCheckoutMerchandiseShippingPointsCalculationRequests = createSelector(
  (state: App.State) => getMerchandiseShippingItemViews(state),
  (merchandiseViews): Array<App.LoyaltyPointsEarnCalculationRequest> => {
    if (!merchandiseViews.hasRequiredData) return EmptyArray

    return merchandiseViews.data.map((itemView): App.LoyaltyPointsEarnCalculationRequest => ({
      price: itemView.totals.otherFees?.deliveryFee ?? 0,
      loyaltyProductType: itemView.loyalty.productType!,
      itemId: itemView.item.itemId,
    }))
  }
)

export default getCheckoutMerchandiseShippingPointsCalculationRequests
